import { DocType } from "./DocType";

export interface CaptureTipFiller {
  tip1Name: string;
  tip2Name: string;
  docType: DocType;
}

export interface CaptureTipMainText {
  order: CaptureTipOrderState;
  text: string;
}

export enum CaptureTipOrderState {
  SINGLE,
  FIRST,
  NOT_FIRST,
}

export class CaptureTips {
  private static FILLERS: CaptureTipFiller[] = [
    {
      docType: DocType.LICENSE_FRONT,
      tip1Name: `the front side of your ID`,
      tip2Name: `ID`,
    },
    {
      docType: DocType.LICENSE_BACK,
      tip1Name: `the back side of your ID`,
      tip2Name: `ID`,
    },
  ];

  private static TIPS: CaptureTipMainText[] = [
    {
      order: CaptureTipOrderState.SINGLE,
      text: `Let’s upload :tip1Name. Position your :tip2Name to fill the entire dotted frame.
           Hold steady, and we’ll take the photo for you.`,
    },
    {
      order: CaptureTipOrderState.FIRST,
      text: `First let’s start with :tip1Name. Position your :tip2Name to fill the entire dotted frame.
           Hold steady, and we’ll take the photo for you.`,
    },
    {
      order: CaptureTipOrderState.NOT_FIRST,
      text: `Well Done! Let’s continue with :tip1Name. Position your :tip2Name to fill the entire dotted frame.
           Hold steady, and we’ll take the photo for you.`,
    },
  ];

  public static getFilledTips = (docType: DocType, orderState: CaptureTipOrderState): string | undefined => {
    const tip = CaptureTips.FILLERS.find( (t) => t.docType === docType);
    const mainText = CaptureTips.TIPS.find( (t) => t.order === orderState);

    if (!tip || !mainText) {
      return undefined;
    }
    let fusedText = mainText.text;
    fusedText = fusedText.replace(":tip1Name", tip.tip1Name);
    fusedText = fusedText.replace(":tip2Name", tip.tip2Name);
    return fusedText;
  };
}



// WEBPACK FOOTER //
// ./src/constants/CameraTips.ts